export default {
  "name": "NCRegisterCom",
  "column": 1,
  "canAppend": false,
  "type": 1,
  "path": "LowCodeComponents.NCRegisterCom",
  "label": "自定义区域",
  "schema": {
    "type": "object",
    "properties": {
      "moduleId": {
        "title": "区域编码",
        "description": "组件标识",
        "type": "string"
      },
      "visible": {
        "title": "是否可见",
        "description": "是否可见",
        "type": "boolean"
      }
    },
    "required": [
      "moduleId"
    ]
  },
  "uiSchema": {},
  "slots": []
}